import React, { ReactNode } from 'react';
import { CanvasCustomConfig } from '../components/canvas-custom-config/canvas-custom-config';
import { AddressSelectionProvider } from './address-selection-indicator/address-selection';
import { AnalyticsContextProvider } from './analytics-context';
import { AppContextProvider } from './app-context';
import { CardContextProvider } from './card-context';
import { CropContextProvider } from './crop-context';
import { InitializationDataContextProvider } from './data-context/data-context';
import { InitializationOnGoingEventsContextProvider } from './on-going-events-context/on-going-events-context';

type ContextProviderProps = {
  children: ReactNode;
  shared?: unknown; // TODO: remove shared props here and below after MIMIR-1795
};

export const ContextProvider = ({ children, shared }: ContextProviderProps) => (
  <InitializationDataContextProvider>
    <AppContextProvider shared={shared}>
      <CardContextProvider>
        <InitializationOnGoingEventsContextProvider>
          <AnalyticsContextProvider shouldInjectScripts>
            <CropContextProvider>
              <CanvasCustomConfig>
                <AddressSelectionProvider>{children}</AddressSelectionProvider>
              </CanvasCustomConfig>
            </CropContextProvider>
          </AnalyticsContextProvider>
        </InitializationOnGoingEventsContextProvider>
      </CardContextProvider>
    </AppContextProvider>
  </InitializationDataContextProvider>
);

// combine and export contexts
